const CSS_CLASSES = {
	ACTIONS: 'root__card__actions',
	CARD: 'root__card',
	CHECKBOX_CONTAINER: 'checkbox-list__container',
	CHECKBOX_ICON: 'checkbox-list__icon',
	CONTAINER: 'root__container',
	CONTROL: 'form-control',
	INVALID: 'root--invalid',
	TITLE_BODY: 'title__body',
	TITLE_BODY_LIST: 'title__body__list',
	TITLE_BODY_LIST_ANCHOR: 'title__body__list__button--anchor',
	TITLE_BODY_LIST_NO_INDENT: 'title__body__list--no-marker',
	TITLE_REDIRECT: 'title__redirect',
	BODY_MESSAGE: 'body__message',
	DATATABLE: 'datatable',
	WARNING: 'warning',
	PAGE_HEADER: 'page__header',
};

export { CSS_CLASSES };
